/**
 * api接口统一管理
 */
import http from '@/v2/utils/http'
import { baseData, examData, networkData, configData } from '@/v2/utils/data'
import { MessageBox } from "element-ui";
import exam_enum from '../../utils/exam_enum';
import { markingData } from '@/v2/utils/fixData'
import util from '@/v2/utils/util'
import markingEnum from "./markingEnum";
import store from '@/vuex/store';

const STS_TOKEN_URL = '/marking-platform/ossUpload/get/fly/sts/token'
const SLS_TOKEN_URL = '/marking-platform/sls/sts'

export const baseApi = {
  getSTSToken: params => http.get(STS_TOKEN_URL, params).then(resp => {
    return {
      region: 'oss-cn-hangzhou',
      bucket: process.env.VUE_APP_OSS_BUCKET,
      secure: true,
      accessKeyId: resp.body.accessKeyId,
      accessKeySecret: resp.body.accessKeySecret,
      stsToken: resp.body.securityToken,
      refreshSTSTokenInterval: 1000 * 60 * 40, // 40分钟
      refreshSTSToken: async () => {
        const info = await http.get(STS_TOKEN_URL, params)
        return {
          accessKeyId: info.body.accessKeyId,
          accessKeySecret: info.body.accessKeySecret,
          stsToken: info.body.securityToken
        }
      }
    }
  }),
  getSlsToken: () => http.get(SLS_TOKEN_URL).then(resp => {
    return {
      ...resp.body,
      refreshSTSToken: async () => {
        const info = await http.get(SLS_TOKEN_URL)
        return info.body
      },
      // 刷新临时访问凭证的时间间隔，单位为毫秒。
      refreshSTSTokenInterval: 1000 * 60 * 40
    }
  }),
  getHistoryYears: params => http.get('/marking-platform/school/upgrade-history', params, 'form'),
  getGrades: params => http.get('/marking-platform/school/grade/school-id/academic-year', params),    // 根据学校、学年获取年级信息
  queryTeachers: params => http.post('/marking-platform/teachers/search', params).then(resp => {
    if (resp && resp.body) {
      networkData.getTodoTeacherList(resp.body.items)
    }
    return resp
  }),
  // 根据学校，年级获取科目
  getGradeSubjects: (params, isFilter = false, isStageFilter = false) => http.post('/marking-platform/configurations/schools/subjects/list', params).then(resp => {
    if (resp.body) {
      return baseData.getTodoSubjects(resp.body, isFilter, isStageFilter)
    }
    return resp
  }),
  // 根据学校、年级(gradeNum) 获取班级列表
  getGradeClassList: (params) => http.post('/marking-platform/school-class/grade-class', params),
  sendMessage: (params) => http.post('/marking-wechat/notify-enterprise-wechat', params),
  getExamClassTeachList_2: (params) => http.get(`/marking-exam-manager/exam_class/teach-class-list/exam-id/${params.examId}/school-id/${params.schoolId}`), // 获取带权限的教学班考试班级
  getExamClassList: (params) => http.get(`/marking-exam-manager/exam_class/list/exam-id/${params.examId}/school-id/${params.schoolId}`), // 获取带权限的考试班级
  getTeacherList: (params) => http.post('/marking-platform/teachers/search/list', params), // 获取教师信息集合
  getStudentList: (params) => http.post('/marking-platform/students/search', params), // 获取学生信息集合
  getExamReportClassList: params => http.get('/marking-statistics/exam-report-class/list/visible', params),// 获取考试报考班级列表
  getSchoolStageList: schoolId => http.get(`/marking-platform/configurations/regions/${schoolId}/stages`, null), // 获取学校下学段信息
  getSixRateConfiguration: params => http.get('/marking-statistics/exam-config/six-rate/school/course', params), // 获取学校六率配置
  getKnpList: (courseId) => http.get('/marking-question/public/question/knowledge-point/courses/' + courseId + '/knowledge-points/tree'),
  getTeachInfo: () => http.get('/marking-platform/user-roles/default/teach-info'),
  getGradeList: (params) => http.post('/marking-platform/school/grade/params', params), // 根据学校、学段获取年级信息
  getQuesTypeList: courseId => http.get('/marking-question/public/qbm/course/' + courseId + '/question-type', { onlyLevel1: true }),
  getTeacherGradeAndSubject: (params) => http.get('/marking-platform/teachers/teacher/subject', params), // 查询任课学科
  checkBuildVersion: () => new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'development') {
      resolve({ message: '开发环境，不检查版本', success: false })
      return
    }
    http.get(process.env.VUE_APP_VERSION_URL + "?t=" + Date.now()).then(version => {
      try {
        const versionStr = JSON.stringify(version)
        const oldVersion = localStorage.getItem('schoolBuildVersion')
        if (oldVersion !== versionStr) {
          localStorage.setItem('schoolBuildVersion', versionStr)
          location.reload()
        }
        resolve({ message: '版本检查成功', body: version })
      } catch (error) {
        resolve({ message: error.message || '版本检查失败' })
      }
    })
  }),
  getRegionSchoolList: schoolId => http.get(`/marking-exam-manager/exam-schools/${schoolId}/sys-school`),
  getRegionSchools: (regionId) => http.get('/marking-platform/school/regionId', { regionId })
}

export const examApi = {
  getGroups: params => http.post("/marking-exam-manager/exam-group/search", params),
  getReportProgress: params => http.post('/marking-statistics/exam-school-state/examIds', params), // 获取报告生成进度
  getGradingProgress: examIds => http.get('/marking-exam-grading/monitor/grading-progress', { examIds: examIds.join(',') }), // 获取批阅进度
  getScanProgress: params => http.post('/marking-exam-manager/student-paper-statistic/student-paper/rce/count', params), // 获取扫描答题卡进度
  getOnlineExam: (params) => http.get('/marking-exam-manager/exam-list/single/' + params.examId), // 获取单场考试
  isNewExam: params => http.get(`/marking-exam-manager/stand/is-new-exam/${params.examId}`), // 判断是否进入标准答案新版页面(非制卡或区域就是新版)
  checkAnswer: (params) => http.get('/marking-exam-grading/grading-task/check-stand-and-doubt', params), // 检查考试是否确认标准答案
  createExamGroup: params => http.post('/marking-exam-manager/exam-group', params),  // 创建考试组
  updateExamGroup: params => http.put(`/marking-exam-manager/exam-group/${params.examGroupId}`, params),// 修改考试组
  copySingle: id => http.post('/marking-exam-manager/exam-list/reuse?examId=' + id), // 复制考试
  deleteSingle: (groupId, examIds) => http.delete(`/marking-exam-manager/exam-group/${groupId}/exam`, examIds), // 删除考试组
  getExam: (examId, isAppend = false) => http.get(`/marking-exam-manager/exam-list/${examId}`).then(resp => {
    examData.getExam(resp, isAppend)
    return resp
  }),
  getGroup: groupId => http.get(`/marking-exam-manager/exam-group/${groupId}`),  // 获取考试组
  getExamGroup: examGroupId => http.get(`/marking-exam-manager/exam-group/${examGroupId}`),  // 获取考试
  listExamTemplate: params => http.post("/marking-exam-manager/answer-sheet/get-unbind-answer-sheet-list", params),
  setScoreType: (params) => http.put(`/marking-exam-manager/exam-list/${params.examId}/score-flag/${params.scoreFlag}`), // 设置阅卷方式
  anewIdentify: (params) => http.post('/marking-exam-manager/recognition/task', params), // 登分框重识别
  getExamDoubt: params => http.get(`/marking-exam-manager/exam/${params.examId}`, params),// 获取疑问项数量
  getReferenceClass: params => http.get(`/marking-exam-manager/exam-base/${params.examId}/grade-class`, params, 'form'), // 获取当前考试参考班级
  bindTemplateCard: (params) => http.put(`/marking-exam-manager/answer-sheet/${params.examId}/bind/${params.id}?version=${params.version}`),
  returnOnlineExamResult: params => http.post("/marking-minipro/online-exam/student/return", params),
  getSheetTemplate: (examId) => http.get(`/marking-exam-manager/answer-sheet/exam-id/${examId}`),// 获取模板信息
  listSingle: (params) => http.post('/marking-exam-manager/exam-list/level-exam/single-exam', params).then(resp => {
    if (resp.body && resp.body.items) {
      resp.body.items.forEach(item => {
        item.typeDesc = exam_enum.getDescByKey(item.type, 'examType')
      });
    }
    return resp
  }),
  queryTaskProgress: tempId => http.get(`/marking-platform/long-task/${tempId}`),// 查询任务进度
  putStudentStatistics: params => http.put("/marking-platform/students/statistic/batch", params),// 基础学生数据批量设置不参与统计
  putExamStudentStatistics: params => http.put("/marking-exam-manager/student-paper-statistic/student-paper/statistics/batch", params), //单科考试设置学生不参与统计
  getStudentMosaicPaper: (params, role) => http.put(`/marking-exam-manager/student-position/${role}/mosaic/url/${params.examId}/${params.resultId}?url=${params.url}`),
  getPositionException: params => http.post('/marking-exam-manager/student-paper-statistic/scan-paper-exception', params),
  gtMultiTemplates: params => http.post('/marking-exam-manager/exam-stand-state/find-by-examIds', params),
  getQuestionList: params => http.post(`/marking-exam-manager/exam/${params.examId}/doubt/search`, params),
  deleteQuestionList: params => http.delete(`/marking-exam-manager/exam/${params.examId}/doubt`, params.doubtIds, "json"), // 删除 疑问项
  updateQuestionMarkNo: params => http.put(`/marking-exam-manager/exam/${params.examId}/doubt/${params.doubtId}/mark_not_find_student`), // 标记无名卷
  updateQuestionList: params => http.put(`/marking-exam-manager/exam/${params.examId}/doubt`, params.doubts),// 修改以问项
  getQuesStandByExamIds: params => http.post('/marking-exam-manager/stand/get-by-examIds', params),// 获取试题结构
  refreshStudentPaper: examId => http.put(`/marking-exam-manager/student-paper/${examId}/fixDetailOssUrl`),
  delScanBatchPaper: (params) => http.delete(`/marking-exam-manager/scan-batch/paper/delete/ids`, params, 'json'), // 删除扫描原卷
  confirmDoubt: (params) => http.put(`/marking-exam-manager/scan-batch/paper/doubt/confirm`, params), // 定位异常的确认
  clearExam: (params) => http.delete('/marking-exam-manager/exam-list/clear_data', params, 'json'), // 删除考试
  getShowChooseSubject: (examId) => http.get(`/marking-exam-manager/student-paper-statistic/${examId}/choose_subject`),
  replaceExamTemp: (params) => http.put(`/marking-exam-manager/answer-sheet/exam-id/${params.examId}/rebind/${params.id}?version=${params.version}`), // 更滑考试模板
  cancelAllAbsenceMarks: (params) => http.post("/marking-exam-manager/student-paper-statistic/student-paper/mark-not-absent", params, 'form'),// 取消全部学生的缺考标记
  getConfigurationParameter: (params) => http.get(`/marking-exam-manager/scan-batch/config/${params.examId}/${params.schoolId}`),// 获取扫描批次模板及扫描人信息
  getScanBatchList: (params) => http.post('/marking-exam-manager/scan-batch/list', params),// 获取扫描信息列表
  getScanBatchProgress: (params) => http.get('/marking-exam-manager/more-paper/scan-paper/process', params),// 获取扫描批次进度信息
  getScanBatchPaperList: (params) => http.post('/marking-exam-manager/more-paper/scan-paper/paper/search', params),// 根据批次获取原卷列表
  delScanBatch: (batchId) => http.delete(`/marking-exam-manager/scan-batch/${batchId}`),// 删除扫描批次
  recoverScan: (examId, ids) => http.put(`/marking-exam-manager/scan-batch/paper/recover?examId=${examId}`, ids),// 恢复识别
  answerSheetStorage: (params) => http.post('/marking-exam-manager/more-paper/scan-paper/result/save', params, 'form'),//  答题卡入库保存
  getPaperProcess: (params) => http.post('/marking-exam-manager/more-paper/paper/process', params),// 获取答题卡进度
  getPaperList: params => http.post('/marking-exam-manager/more-paper/paper/search', params),// 获取答题卡列表
  delPaperInfo: params => http.delete('/marking-exam-manager/more-paper/paper', params),// 删除答题卡
  getPaperPageList: params => http.get('/marking-exam-manager/more-paper/paper/page-index', params),// 获取试卷页面集合
  changeStudentPaper: params => http.put('/marking-exam-manager/more-paper/paper/change-paper', params),// 修改学生答题卡
  markBlankPaper: (examId, params) => http.post('/marking-exam-manager/more-paper/scan-paper/paper/blank?examId=' + examId, params),// 标记白卷
  getExamPaperDetail: params => http.get("/marking-exam-manager/student-paper-statistic/student-score", params).then(resp => {
    if (resp.success && resp.body) {
      networkData.getExamPaperDetails(resp.body)
    }
    return resp
  }),
  getStandAnswerList: examId => http.get(`/marking-exam-manager/stand/school/${examId}`).then(resp => {
    return networkData.getStandAnswerList(resp)
  }),// 获取所有答案
  putStandAnswerList: (examId, params) => http.put(`/marking-exam-manager/more-paper/stand/${examId}`, params),// 修改答案
  getQuestion: (params) => http.post('/marking-question/public/question/info/by/question/ids', params),// 获取题目信息
  getBatchList: params => http.post('/marking-exam-manager/scan-batch/simple-list', params),// 获取批次列表
  getExamNotUploadCount: (params) => http.get('/marking-exam-manager/exam-dashboard/unUpload/count', params),
  // 还原到原卷
  restoreScanBatchPaper: ids => http.put(`/marking-exam-manager/recognition/recover/source-paper`, ids),
  setPaperPositionError: (examId, ids) => http.put(`/marking-exam-manager/exam/${examId}/mark-position-exception`, ids), // 标记定位异常
  getQuestionPosition: params => http.get(`/marking-exam-manager/exam/${params.examId}/detail/${params.detail}/position`), // 获取题目坐标
  getTeacherExamList: (params) => http.get('/marking-exam-manager/exam-base/teacher/exams', params), 		//查询老师相关考试
  getExamTotalScore: examId => http.get('/marking-statistics/exam-score/single/total-score', { examId }), //获取考试总分
  getRegionExamGroup: (examGroupId, schoolId) => http.get(`/marking-exam-manager/exam-group/region/${examGroupId}/find-by-school/${schoolId}`), // 获取区域考试组
  updateRegionExam: params => http.put('/marking-exam-manager/exam-group/region/update-by-school', params), // 更新区域考试
  getListAllStand: (examId, platform = 'school') => http.get(`/marking-exam-manager/stand/${platform}/${examId}`).then(resp => {
    examData.setToDoQuestionStand(resp)
    return resp
  }), // 获取所有标准答案(模板一和二)
  saveAffirmAllList: (params, platform = 'school') =>
    http.put(`/marking-exam-manager/stand/${platform}/${params.examId}`, params), // 保存所有标准答案(模板一和二)
  getRegionExamSchoolDoubtList: (examId, params) => http.get(`/marking-exam-manager/exam/${examId}/school/doubt/count`, params), // 学校疑问项统计
  updateQuestionNum: params => http.put(`marking-exam-manager/exam/${params.examId}/doubt/num`, params), // 重置计数
  getAuditExamCount: (schoolId) => http.get(`/marking-exam-manager/exam-base/approving-count/school-id/${schoolId}`),
  checkImport: params => http.get(`/marking-exam-manager/exam-list/${params.examId}/hasResult`),
  getExamPaperStatus: (ids) => http.post('/marking-exam-manager/exam-list/exam-paper-status', ids),
  splitSchoolExam: params => http.post("/marking-exam-manager/split-exam/to-exam-group", params), // 拆分考试
  getExamGroupSimpleInfo: examId => http.get('/marking-exam-manager/exam-group/simple-exam-group/exam-id/' + examId), // 获取考试组列表
  // 获取考试列表
  getListExam: params => http.post('/marking-exam-manager/exam-list/single/search', params).then(resp => {
    if (resp && resp.body) {
      resp.body.items.forEach(item => {
        item.isMore = exam_enum.getCodeByKey(item.isMore)
        item.importType = exam_enum.getCodeByKey(item.importType)
        item.scoreFlagDesc = item.scoreFlag === 0 ? '待选择' : exam_enum.getDescByKey(item.scoreFlag)
        item.scoreFlag = exam_enum.getCodeByKey(item.scoreFlag)
        item.examTypeName = exam_enum.getDescByKey(item.type)
        item.type = exam_enum.getCodeByKey(item.type)
        item.standConfirm = exam_enum.getCodeByKey(item.standConfirm)
        item.hasPaper = exam_enum.getCodeByKey(item.hasPaper)
        item.hasStand = exam_enum.getCodeByKey(item.hasStand)
        item.disSucNum = 0
        if (item.reportState) {
          item.reportState.examSign = exam_enum.getCodeByKey(item.reportState.examSign)
          item.reportState.qualitySign = exam_enum.getCodeByKey(item.reportState.qualitySign)
        }

        if (item.examSchools) {
          item.disSucNum = item.examSchools[0].disSucNum || 0 // 赋值在线考试学生识别数
          item.examSchools.forEach(school => {
            school.isGrading = exam_enum.getCodeByKey(school.isGrading)
          })
        }
      })
    }
    return resp
  }),
  getSchoolProgress: targetId => http.get(`/marking-exam-manager/exam-group/school/progress/${targetId}`), // 获取学校处理进度
   getOcrTask: schoolId => http.get(`/marking-exam-manager/stand/${schoolId}/re_ocr/task`) // 获取Ocr任务
}

export const reportApi = {
  createGroupReport: examGroupId => http.post('/marking-exam-manager/exam-group/report/add?examGroupId=' + examGroupId), // 生成多科报告
  refreshSingleReport: params => http.post('/marking-statistics/statistics/single/initiative/send', params, 'form'), // 刷新报告
  reportPaper: params => http.get('/marking-statistics-report/paper/review', params), // 报告里考试的信息
  reportQuality: params => http.get('/marking-statistics-report/paper/analysis', params), // 质量报告
  updateMuliSubject: params => http.put('/marking-statistics/multi-exam/update/multiple/exam', params), // 修改统计科目，会触发考试报告重新生成
  multiReportState: id => http.get(`/marking-statistics/multi-exam/${id}/simple`),
  createReportExport: params => http.post(`/marking-statistics-download/report/task/save`, params),// 创建年级导出报告
  refreshReportExport: params => http.post('/marking-statistics-download/report/task/refresh', params), // 刷新年级导出报告
  getClassReviewingTheTestPapers: params => http.post(`/marking-statistics-download/report/task/list/exam/${params.examId}/school/${params.schoolId}/class/type/${params.type}`, params.classIds), // 获取班级试卷讲评列表
  getReadMarkExportList: params => http.post(`/marking-statistics-download/grading/task/list/exam/${params.examId}/school/${params.schoolId}`, params.types), // 获取批阅报告导出列表
  createReadMarkExport: params => http.post('/marking-statistics-download/grading/task/save', params),// 创建批阅报告
  refreshReadMarkExport: params => http.post('marking-statistics-download/grading/task/refresh', params), // 刷新批阅导出报告
  accordingToClass: (examId, schoolId) => http.post(`/marking-statistics/statistics/single/according/to/class?examId=${examId}&schoolId=${schoolId}`), // 单科考试分班统分
  examClassReportState: (examId, schoolId) => http.get(`/marking-statistics/exam-class-report-state/list?examId=${examId}&schoolId=${schoolId}`),
  getClassAnalysis: params => http.get('/marking-statistics-report/custom/all/class/question/analysis', params),//班级自定义分析（班级分析）
  setQuesGroupRadio: (params) => http.post('/marking-statistics/exam-config/custom/question/group/ratio?examId=' + params.examId + '&schoolId=' + params.schoolId, params),//班级试题得分率配置
  getQuesGroupRadio: (params) => http.get('marking-statistics/exam-config/custom/question/group/ratio', params),// 获取自定义比例范围配置
  classCustStudent: (params) => {
    const path = `/marking-statistics-report/custom/page/student/question/analysis?examId=${params.examId}&schoolId=${params.schoolId}&pageNo=${params.pageNo}&pageSize=${params.pageSize}&isTeachClass=${params.isTeachClass}`
    return http.post(path, params.classIds)
  },//班级自定义分析（学生分析）
  setQuesGroup: (params) => http.post('marking-statistics/exam-config/custom/question/group?examId=' + params.examId + '&schoolId=' + params.schoolId, params.list),//班级自定义分析配置
  getQuesGroup: (params) => http.get('/marking-statistics/exam-config/custom/question/group', params),// 获取自定义比例范围配置
  getGradeBasicIndicators: (params) => http.get(`/marking-statistics-report/single/basic/index/school/all/${params.type}/class`, params),//获取年级基础指标数据
  getGradeBasicIndicatorsTarget: examId => http.get(`/marking-statistics/exam-config/basic-index/${examId}`), // 获取年级基础指标配置
  getAcademicLevelConfig: examId => http.get(`/marking-statistics/exam-config/academic-level-distribution/${examId}/user/common`), // 获取学业等级分布个人配置
  getAcademicLevelList: params => http.post(`/marking-statistics-report/single/school/${params.type}/basic/info/all/class/academic/level/statistics?schoolId=${params.schoolId}&examId=${params.examId}`), // 获取学业等级分布
  updateAcademicLevelUserConfig: params => http.post(`/marking-statistics/exam-config/academic-level-distribution/${params.examId}/user`, params), // 更新学业等级分布个人配置
  getComparisonConfig: examId => http.get(`/marking-statistics/exam-config/comparison/${examId}/user`),// 获取学校任意考试对比分析配置
  saveComparisonConfig: params => http.post(`/marking-statistics/exam-config/comparison/${params.examId}/user`, params.examIds),// 更新学校任意考试对比分析配置
  getSchoolAnyExamAnalysis: params => http.get(`/marking-statistics-report/custom/exam/comparison/grade/${params.examId}`, params),//获取单校任意考试对比分析报表
  getSingleGradeRanking: (type, params) => http.get(`/marking-statistics-report/single/ranking-section/${type}/class`, params), //查询单科年级名次对比
  getExamReferenceStudentCount: (key, params) => http.post(`/marking-statistics-download/${key}/paper/student/count`, params), // 获取考试参考学生数量
  getClassStability: params => http.get(`/marking-statistics-report/single/class/${params.type}/basic/info/all/class/quartile/analysis`, params),//四分位数
  getGradeStability: params => http.get(`/marking-statistics-report/single/school/${params.type}/basic/info/all/class/quartile/analysis`, params),//四分位数
  getStudentAnalysis: params => http.get(`/marking-statistics-report/question-group/exam/${params.examId}/student`, params), // 获取学生题组
  getExamQuestionGroup: examId => http.get(`/marking-statistics/exam-config/question-group/${examId}`), // 获取考试题组
  saveExamQuestionGroup: (examId, params) => http.post(`/marking-statistics/exam-config/question-group/${examId}`, params), // 保存考试题组
  getExamQuestionGroupAnalysis: (schoolId, params) => http.post(`/marking-statistics-report/question-group/class/analysis?schoolId=${schoolId}`, params), // 获取题组分析
  getExamItemAnalysisList: params => http.get(`/marking-statistics-report/question-contrastive/option/school/${params.type === 'admin' ? 'sub-class' : 'sub-teach-class'}`, params).then(resp => {
    if (resp.body && resp.body.questionInfos) {
      resp.body.questionInfos.forEach(item => {
        item.choiceTypeDesc = exam_enum.getDescByKey(item.choiceType)
      })
    }
    return resp
  }), // 获取试题分析列表
  getStudentItemAnalysisList: params => http.get(`/marking-statistics-report/question-score/${params.type === 'admin' ? 'class' : 'teach-class'}`, params), // 获取学生试题分析
  getGradeMultipleBaseList: params => http.get(`/marking-statistics-report/multiple/basic/index/school/all/subject`, params), // 查询年级多科基础指标分析
  getClassMultipleBaseList: params => http.get(`/marking-statistics-report/multiple/basic/index/class/all/subject`, params), // 查询年级多科基础指标分析
  getMultipleBasicIndicators: params => http.get('/marking-statistics-report/multiple/basic/index/final/summary/all/class', params),//获取多科基础指标
  startExportTask: params => http.post('/marking-statistics-download/report/task/upsert', params), // 触发导出报告任务
  checkExportTask: params => {
    let url = `/marking-statistics-download/report/task/list/exam/${params.examId}/school/${params.schoolId}`
    if (params.classId) {
      url += `?param=${params.classId}`
    }
    return http.post(url, params.types) // 获取年级报告导出列表
  },
  getClassBasicIndexList: params => http.get(`/marking-statistics-report/single/basic/index/school/${params.classType}/class`, params),
  studentRanking: params => http.get('/marking-statistics-report/student-ranking/school', params),// 查询班级学生成绩排名
  getShowRanking: params => http.get('/marking-platform/configurations/show/ranking/course', params),// 获取是否显示排名
  studentRankingByMultiple: params => http.post('/marking-statistics-report/multiple/student-ranking/school', params),// 查询班级学生成绩排名
  getGradeQuestionScoreList: params => http.get('/marking-statistics-report/question-contrastive/kqa/school', params),
  getGradeMultiple343: params => http.get('/marking-statistics-report/multiple/student-ranking/school/class/student/343', params),
  getClassMulti343Score: (params) => http.get('/marking-statistics-report/multiple/student-ranking/class/student/distribution', params),//查询班级多科3-4-3
  getClassSingle343Score: params => http.get('/marking-statistics-report/student-ranking/class/student/distribution', params),
  getClassMultiNumberPeople: params => http.get('/marking-statistics-report/multiple/basic/index/school/class/index', params),
  getClassSingleNumberPeople: params => http.get('/marking-statistics-report/single/basic/index/school/admin/class/index', params),
  getClassMultiRanking: (params) => http.get('/marking-statistics-report/multiple/subject-ranking/class', params),//查询班级优劣势学科分析
  getMultipleGradeStability: (params) => http.get('/marking-statistics-report/multiple/quartile/school/all/subject', params), // 四分位
  getClassMultiStability: (params) => http.get('/marking-statistics-report/multiple/quartile/class/all/subject', params), //四分
  postClassMultiScore: (params) => http.post('/marking-statistics-report/multiple/score_section/class', params), //查询班级多科总分分数段对比
  getClassIndexTrend: (type, params) => http.get(`/marking-statistics-report/single/basic/index/school/${type}/class/trend`, params),//班级基础指标趋势
  getClassDistribution: (type, params) => http.get(`/marking-statistics-report/single/basic/index/school/${type}/class/index`, params),//班级成绩分布
  getClassRanking: (type, params) => http.get(`/marking-statistics-report/single/basic/index/school/${type}/class/index`, params),//班级3-4-3分布
  getStudentDistribution: (params) => http.get('/marking-statistics-report/student-ranking/class/student/distribution', params),//班级学生成绩分布
  classRankingWave: (params) => http.get('/marking-statistics-report/student-ranking/class/student/wave', params),//班级波动生
  classCritical: (params) => http.get('/marking-statistics-report/student-ranking/class/student/critical', params),//班级临界生
  getStudentQrUrl: taskId => http.get(`/marking-platform/task/student-qr/schools/cache/${taskId}`), // 获取导出报告下载地址
  classSingeNameRanking: (params) => http.get('/marking-statistics-report/single/ranking-section/admin/class', params),//查询班级多科年级名次对比
  classMultiNameRanking: (params) => http.get('/marking-statistics-report/multiple/ranking-section/class', params),//查询班级多科年级名次对比
  getStudentBase: (examId, studentId, params) => http.get(`/marking-statistics-report/student/report/single/exam/${examId}/student/${studentId}`, params),//查询学生考试总体水平
  getRatioSetting: (params) => http.get('/marking-statistics/exam-config/question/score/ratio', params),//举一反三解析
  postRatioSetting: (params) => http.post('/marking-statistics/exam-config/question/score/ratio', params, 'form'),//举一反三解析
  getClassStatistics: (type, params) => http.post(`/marking-statistics-report/kqa/${type}/class`, params), // 查询班级学科分析
  getGradeStatistics: (params) => http.post("/marking-statistics-report/kqa/grade", params), // 查询年级学科分析
  getPointAnalysis: () => http.get('/marking-statistics-report/kqa/level'), // 获取知识点分析层级
  getStuBase: (examId, studId, params) => http.get(`/marking-statistics-report/student/report/single/exam/${examId}/student/${studId}`, params),//查询学生成绩单基本信息
  getExamKqaByType: (examId, schoolId, studentId, type, params) => http.get(`/marking-statistics-report/student/report/single/exam/${examId}/school/${schoolId}/student/${studentId}/kqa/${type}`, params),
  getStudentOverview: (params) => http.get('/marking-statistics-report/student/archive/overview', params), //学生档案概述
  getStudentComprehensive: (params) => http.get('/marking-statistics-report/student/archive/subject-score-rate-compare', params), //查询学生综合得分
  bestAndWorstExam: (params) => http.get('/marking-statistics-report/student/archive/best-and-worst-exam', params), //学生最优和最差考试
  examOverview: (params) => http.get('/marking-statistics-report/student/archive/exams/subject', params), //学生考试概览
  studentQuestionHard: (params) => http.get(`/marking-statistics-report/student/report/single/exam/${params.examId}/school/${params.schoolId}/class/${params.classId}/student/${params.studentId}/difficulty`, params.param),//查询学生难易得分情况
  studentExamHistory: (params) => http.get(`/marking-statistics-report/student/report/single/exam/${params.examId}/student/${params.studentId}/history`),//查询学生历次考试情况
  pointOverview: (params) => http.get('/marking-statistics-report/student/archive/subject-knp-statistics', params),//考点掌握情况
  pointOverviewDetail: (params) => {
    let url = '/marking-statistics-report/student/archive/subject-knp-detail'
    if (util.isEmpty(params.data)) {
      alert(location.href)
      return Promise.resolve([])
    } else {
      url += util.transformUrlParams(params.data)
    }
    return http.post(url, params.subject)
  }, //考点掌握情况详细
  pointQuestion: (params) => {
    let url = '/marking-statistics-report/student/archive/question-point-info'
    if (util.isEmpty(params.data)) {
      alert(location.href)
      return Promise.resolve([])
    } else {
      url += util.transformUrlParams(params.data)
    }
    return http.post(url, params.examIds)
  }, //获取知识点对应的题目
  getSummaryClassRankCompare: (levelExamId, schoolId, params) => http.get(`/marking-statistics-report/school/summary/rankingComparison/${levelExamId}/${schoolId}`, params), // 各班主科年级名次对比
  getMainClassRankCompare: (levelExamId, schoolId, params) => http.get(`/marking-statistics-report/school/main/rankingComparison/${levelExamId}/${schoolId}`, params), // 各班主科年级名次对比
  getSummaryClassScoreCompare: (levelExamId, schoolId, params) => http.get(`/marking-statistics-report/school/summary/sectionComparison/${levelExamId}/${schoolId}`, params).then(resp => {
    if (resp.success && resp.body.length > 0) {
      resp.body = resp.body.filter(item => item.orgId != schoolId)
    }
    return resp
  }), // 各班总分分数段对比
  getMainClassScoreCompare: (levelExamId, schoolId, params) => http.get(`/marking-statistics-report/school/main/sectionComparison/${levelExamId}/${schoolId}`, params).then(resp => {
    if (resp.success && resp.body.length > 0) {
      resp.body = resp.body.filter(item => item.orgId != schoolId)
    }
    return resp
  }), // 各班总分分数段对比
  getSummaryStudentRank: params => http.post("/marking-statistics-report/school/summary/pageReportCard", params), // 学生成绩单
  getTeacherClassExamInfo: (params) => http.get("/marking-statistics-report/teacher/archive/exam/situation", params), // 任课班级考试趋势（班级排名）
  getTeacherClassTeach: (params) => http.get('/marking-statistics-report/teacher/archive/class/overview', params), // 任课班级基本情况
  getTeacherClassExamRank: (params) => http.get('/marking-statistics-report/teacher/archive/exam/class/index/list', params), // 任课班级考试趋势（班级排名）
  getTeacherDataCount: (params) => http.get('/marking-statistics-report/teacher/archive/data/view', params), 	// 数据总览
  setScoreSection: (params) => http.post(`/marking-statistics/exam-config/score/section?schoolId=${params.schoolId}&examId=${params.examId}&scoreSection=${params.scoreSection}&minScore=${params.minScore}`, {}), // 任课班级多科年级名次对比
  getScoreSection: (params) => http.get('/marking-statistics/exam-config/score/section', params), // 任课班级多科总分分数段对比
  getExamStatus: params => http.get("/marking-exam-grading/exam/grad/get-status", params), // 获取考试状态
  getMultiReportSign: examIds => http.post('/marking-statistics/multi-exam/list/final-sign', examIds), // 获取多科考试报告状态
  updateMultiExam: (params, isRegion) => http.put(`/marking-statistics/multi-exam/${params.id}?isRegion=${isRegion}`, params), // 更新多科考试
  addMultiExam: (params, isRegion) => http.post(`/marking-statistics/multi-exam?isRegion=${isRegion}`, params), // 新增、创建多科考试
  // 获取多科考试详情
  getMultiExamInfo: (params, isRegion) => http.get(`/marking-statistics/multi-exam/${params.examId}?isRegion=${isRegion}`).then(resp => {
    if (resp.success && resp.body) {
      const base = resp.body
      base.examBaseVos.forEach(element => {
        element.typeDesc = exam_enum.getDescByKey(element.type)
        element.standConfirmCode = exam_enum.getCodeByKey(element.standConfirm)
        element.hasPaperCode = exam_enum.getCodeByKey(element.hasPaper)

        if (element.reportState) {
          element.reportState.examSign = exam_enum.getCodeByKey(element.reportState.examSign)
          element.reportState.qualitySign = exam_enum.getCodeByKey(element.reportState.qualitySign)
        }
      })

      base.date = util.formatDate(base.createTime) // 格式化时间戳
      // base.gradeName = util.serializeGrade(base.grade) // 转换年级
      base.subjectList = []
      for (const sub of base.examBaseVos) {
        const subjectName = sub.subjectName ? sub.subjectName.substr(0, 1) : '-'
        base.subjectList.push(subjectName)
      }
    }
    return resp
  }),
  // 获取多科考试详情
  getLevelExam: (levelExamId, isRegion = false) => http.get(`/marking-statistics/level/exam/${levelExamId}?isRegion=${isRegion}`).then(resp => {
    if (resp.body) {
      resp.body.type = exam_enum.getCodeByKey(resp.body.examType)
      resp.body.examLineTypeCode = exam_enum.getCodeByKey(resp.body.examLineType)
    }
    return resp
  }),
  getExamSchoolList: (params) => http.get('/marking-platform/regions/schools/exam-schools', params).then(resp => {
    if (resp.body) {
      for (let index = 0; index < resp.body.length; index++) {
        const element = resp.body[index];
        element.groupName = element.name
        element.school = element.sysSchoolGradeDetails
      }
    }
    return resp
  }),
  getCitySchools: (params) => http.get('/marking-platform/regions/schools/cities/exam-schools', params, 'form'), // 获取市下面的学校
  addExam: (params, isRegion = false) => http.post(`/marking-statistics/level/exam?isRegion=${isRegion}`, params), // 创建考试
  updateExamLevel: (params, isRegion = false) => http.put(`/marking-statistics/level/exam/${params.levelExamId}?isRegion=${isRegion}`, params) // 编辑考试
}

export const gradingApi = {
  startAll: (schoolId, examId) => http.post('/marking-exam-grading/grading-status/start/main', { schoolId, examId }), // 批阅总开始
  endAll: (schoolId, examId) => http.put('/marking-exam-grading/grading-status/finish?schoolId=' + schoolId + '&examId=' + examId), // 结束批阅
  recover: (schoolId, examId) => http.post('/marking-exam-grading/grading-status/recover', { schoolId, examId }), // 恢复批阅
  getTeacherTaskList: (params) => http.post('/marking-exam-grading/grading-task/teacher-mode/task-list', params).then(resp => {
    return markingData.fixWuHenSet(resp)
  }), // 查询批阅设置
  getReview: params => http.get("/marking-exam-grading/grading-task/get-review", params, "form"), // 获取考试抽样复评状态
  updateReview: params => http.post('/marking-exam-grading/grading-task/update-review', params), // 更新考试抽样复评状态
  delAllTask: params => http.post('/marking-exam-grading/grading-task/delete/all/long-task', params), // 批量删除批阅任务
  gradingList: params => http.post('/marking-exam-grading/exam-list/school/to-be-graded', params), // 待批改列表
  getStatus: params => http.get("/marking-exam-grading/exam/grad/get-status", params), // 获取考试状态
  getAllGradingTeacher: (examId, schoolId) => http.get('/marking-exam-grading/grading-teacher/all', { examId, schoolId }), // 获取发送批阅通知教师列表 - 全部
  sendGradingSMS: (examId, schoolId, teacherIds) => http.put(`/marking-exam-grading/notice/grad?examId=${examId}&schoolId=${schoolId}&teacherIds=${teacherIds}`), // 发送批阅通知短信
  setTeamLeader: (params) => http.post('/marking-exam-grading/grading-task/set-team-leader', params), // 设置阅卷组长
  getAssignMode: params => {
    if (!params.examId || !params.schoolId) {
      alert(location.href)
      return Promise.resolve({})
    }
    return http.get("/marking-exam-grading/grading-task/get-assign-mode", params) // 查询批阅方式
  },
  updateAssignMode: params => http.post('/marking-exam-grading/grading-task/school/set-assign-mode', params),// 更新批阅方式
  getClassMarkList: params => http.post('/marking-exam-grading/grading-task/school/class-mode/task-list', params).then(resp => {
    if (resp.body) {
      resp.body.isGrading = exam_enum.getCodeByKey(resp.body.isGrading)
    }
    return resp
  }), // 获取班级批阅列表
  createClassMarkTask: params => http.post('/marking-exam-grading/grading-task/school/class-mode/add-all-task', params), // 创建班级批阅
  updateAllClassMarkTask: params => http.post('/marking-exam-grading/grading-task/school/class-mode/modify-all-task', params), // 全局修改批阅任务
  updateClassMarkTask: params => http.post('/marking-exam-grading/grading-task/school/class-mode/modify-task', params), // 修改批阅任务
  addQuestionTask: params => http.post('/marking-exam-grading/grading-task/school/class-mode/add-question', params), // 新增题块任务
  addClassTask: params => http.post('/marking-exam-grading/grading-task/school/class-mode/add-task', params), // 新增班级任务
  clearClassMarkTask: params => http.post('/marking-exam-grading/clear-score/by-class', params), // 清空批阅任务
  startWuhen: params => http.post('/marking-exam-grading/grading-status/start/main', params), // 开始批阅
  pauseWuhen: params => http.post('/marking-exam-grading/grading-status/pause/main', params), // 暂停批阅
  deleteWuhenSet: (params) => http.post('/marking-exam-grading/grading-task/delete/long-task', params), // 删除批阅设置
  endWuhen: params => {
    return http.get('/marking-exam-grading/grading-status/check-finish', params).then(resp => {
      if (resp.result) {
        const { message, detail } = networkData.getCheckTip(resp.result)
        MessageBox.confirm(detail, '结束批阅异常', { type: 'error', dangerouslyUseHTMLString: true })
          .then(() => { }).catch(() => { })
        return { message, code: 201 }
      } else {
        return http.put('/marking-exam-grading/grading-status/finish', params, 'form')
      }
    })
  }, // 结束批阅并生成报告
  addWuhenSet: params => {
    markingData.trySetParams(params)
    return http.post('/marking-exam-grading/grading-task/teacher-mode/add-task', params)
  },
  updateWuhenSet: params => {
    markingData.trySetParams(params)
    return http.post('/marking-exam-grading/grading-task/modify-type', params)
  },
  continueExamGrading: params => http.post('/marking-exam-grading/grading-status/start/group', params), // 继续网络阅卷
  pauseExamGrading: params => http.post("/marking-exam-grading/grading-status/pause/group", params), //暂停网络阅卷
  getQuestionGroupNum: params => http.post("/marking-exam-grading/grading-task/school/task-info", params).then(resp => {
    return markingData.fixQuestionGroupNum(resp)
  }), // 获取题组分配数
  clearAllTask: params => http.post('/marking-exam-grading/clear-score/all/long-task', params),
  clearGroupTask: params => http.post("/marking-exam-grading/clear-score/group/long-task", params),
  getQuestionItem: params => http.post('/marking-exam-grading/grading/question/item', params).then(resp => {
    if (resp.body) {
      const { toDoQuestions, toDoItem } = networkData.getTodoQuestions(resp.body, params.num)
      resp.toDoQuestions = toDoQuestions
      resp.toDoItem = toDoItem
    }
    return resp
  }), // 获取题块信息
  readOver: params => http.put('/marking-exam-grading/grading/question/item', params), // 添加分值
  updateReadOver: (params) => http.put('/marking-exam-grading/grading/question/item/update', params), // 修改批阅
  getReadOverHistory: params => http.post("/marking-exam-grading/grading/read-over/history", params).then(resp => {
    if (resp.body.items) {
      networkData.getTodoQuestions2(resp.body.items)
    }
    return resp
  }),
  updateReadOverHistory: params => http.put("/marking-exam-grading/grading/read-over/history", params),
  getReviewStudentName: params => http.get('/marking-exam-grading/exam-result/students', params), // 获取批阅学生姓名
  getQuestionSchedule: params => http.get('/marking-exam-grading/monitor/teacher-grading-count', params),// 获取批阅进度
  allocationCopy: (params) => http.post('/marking-exam-grading/grading-task/copy', params), // 复制批阅任务
  getExamQuestions: params => http.get(`/marking-exam-grading/grading-teacher/stands`, params, "form"), // 获取考试题目
  getTeacherGradingInfo: params => http.get('/marking-exam-grading/grading-teacher/grading-nums', params),// 获取教师分工信息
  // 获取区域考试批阅信息
  getRegionExam: params => http.post(`marking-exam-grading/grading-task/school-assign-region-teacher/school/task-list/enum-version`, params).then(resp => {
    return markingData.fixWuHenSet(resp, 'tasks')
  }),
  // 修改批阅设置
  updateMarkingMode: params => http.post('/marking-exam-grading/grading-task/school-assign-region-teacher/school/modify-teacher-and-assign-type', params), // 更新批阅方式
  startExamBySchool: params => http.post('/marking-exam-grading/grading-status/region/school-mode/start/school', params), // 单校开启批阅
  pauseExamBySchool: params => http.post('/marking-exam-grading/grading-status/region/school-mode/pause/school', params), // 单校暂停批阅
  queryCheckTeacher: (params) => http.get(`/marking-exam-grading/grading-teacher/all`, params, "form").then(res => {
    if (res.success && res.body.length > 0) {
      for (let index = 0; index < res.body.length; index++) {
        const element = res.body[index];
        element.nickName = element.nickName ? element.nickName : element.id.substring(element.id.length - 6) + '(已删除)'
      }
    }
    return res
  }),
  getCheckTeacher: (params) => http.get(`/marking-exam-grading/grading-teacher/region-grading/school`, params),
  // 获取阅卷质量
  queryQualityData: params => http.get(`/marking-exam-grading/monitor/grading-quality`, params, "form").then(resp => {
    return networkData.getReadQuality(resp)
  }),
  getQualityData: params => http.get(`/marking-exam-grading/monitor/region/school/grading-quality`, params, "form").then(resp => {
    return networkData.getReadQuality(resp)
  }),
  // 获取评分分布
  queryScoreSpread: params => http.get("/marking-exam-grading/monitor/score-distribution", params).then(resp => {
    return networkData.getScoreSpread(resp)
  }),
  getScoreSpread: params => http.get("/marking-exam-grading/monitor/region/school/score-distribution", params).then(resp => {
    return networkData.getScoreSpread(resp)
  }),
  // 查询批阅进度
  queryProgressList: (params) => http.get('/marking-exam-grading/monitor/schedule', params),
  getProgressList: (params) => http.get('/marking-exam-grading/monitor/region/school/schedule', params),
  updateReadMark: async (params, ques) => {
    try {
      await networkData.setExamMarkVos(params, ques)
    } catch (error) {
      window.SlsSend({
        action: 'setExamMarkVos',
        desc: '批阅页面-更新标记接口调用调用前失败',
        data: {
          error,
          params,
          ques
        }
      })
    }
    return http.put('/marking-exam-grading/exam-grading/mark', params)
  },
  getReadMark: (params, ques, isSetMark = true) => {
    return http.get('/marking-exam-grading/exam-grading/mark', params).then(resp => {
      if (resp.body && isSetMark) {
        networkData.setImageMarks(ques, resp.body)
      }
      return resp
    })
  },
  releaseTimeoutTask: params => http.put('/marking-exam-grading/grading/question/item/release', params, 'form'),//释放超时任务
  backGradingInfo: params => http.delete('/marking-exam-grading/grading/question/item/delete-and-callback', params, 'json'), // 回退批阅信息
  getGradingStatus: params => http.get('/marking-exam-grading/grading-status/get-grading-status', params),// 获取指定任务的批阅状态,YES是暂停，NO是未暂停
  getMarkTeacher: params => http.post('/marking-exam-grading/grading-task/teacher-mode/grading-teacher', params),// 获取批阅教师
  copyMarkTask: params => http.post('/marking-exam-grading/grading-task/teacher-mode/copy-task', params),//复制批阅任务
  updateAssignType: ({ assignType, teachers, type, examId, groupId, schoolId }) => {
    const params = {
      firstTeachers: [],
      examId, groupId,
      schoolId: schoolId
    }
    // 如果修改仲裁分配方式，修改judgeType就行了，assignType和firstTeachers可以为空 @xiaoguang
    if (type === 2) {
      params.judgeType = markingEnum.AssignType[assignType]
    } else {
      params.assignType = markingEnum.AssignType[assignType]
      if (teachers && teachers.length > 0) {
        for (let index = 0; index < teachers.length; index++) {
          const { teacherName, teacherId, todoGradingNum } = teachers[index];
          params.firstTeachers.push({ teacherName, teacherId, todoGradingNum })
        }
      }
    }
    return http.post('/marking-exam-grading/grading-task/teacher-mode/modify-assign-type', params)
  }, // 更新题组分配方式
  updateAssignTeacher: (params) => {
    params.schoolId = params.regionId
    if (params.type === 1) {
      params.firstTeachers = params.teachers
    } else {
      params.secondTeachers = params.teachers
    }
    delete params.teachers
    delete params.type
    return http.post('/marking-exam-grading/grading-task/teacher-mode/modify-grading-teacher', params)
  }, // 更新题组批阅老师
  seAllAssignByTeacher: params => http.post('/marking-exam-grading/grading-task/teacher-mode/batch-modify-assign-type', params), // 区域教师模式，批量设置阅卷分配方式
}

export const mainApi = {
  getExamPerms: params => http.post('/marking-platform/user-roles/get-permissions-by-exams?schoolId=' + params.schoolId, params.ids), // 获取考试的角色权限
}

export const clientApi = {
  initScanBatch: (params = {}) => {
    if (params.examId) {
      const query = [
        `examId=${params.examId}`,
        `schoolId=${params.schoolId}`
      ]
      const keys = ['templateNum', 'enableImageEnhancement', 'dogEarDetection']
      keys.forEach(key => {
        if (params[key]) query.push(`${key}=${params[key]}`)
      })
      return http.post(`/marking-exam-manager/tiny-client/scan-batch?${query.join('&')}`, {})
    } else {
      return Promise.resolve({ body: { id: 'TEMP_BATCH' } })
    }
  },
  uploadPaper: params => http.post('/marking-exam-manager/tiny-client/paper', params),
  getScanConfig: () => http.get('/marking-exam-manager/tiny-client/config'),
  setScanConfig: params => http.put('/marking-exam-manager/tiny-client/config', params),
  setMaxScan: params => http.post('/marking-exam-manager/tiny-client/max-scan', params),
  getExeUrl: () => new Promise((resolve, reject) => {
    const which = process.env.NODE_ENV === 'production' ? 'prod' : 'test'
    const baseUrl = `https://oss-rbm-static.oss-cn-hangzhou.aliyuncs.com/mrc/${which}`
    const url = `${baseUrl}/latest.yml`
    http.download(url).then(file => {
      const reader = new FileReader();
      reader.readAsText(file, 'UTF-8');
      reader.onloadend = function () {
        try {
          const fileStrs = reader.result.split('\n')
          const pathStr = fileStrs.find(item => item.indexOf('path:') >= 0)
          const fileName = pathStr.split(':')[1]
          const donwlodUrl = `${baseUrl}/${fileName.trim()}`
          resolve(donwlodUrl);
        } catch (error) {
          resolve('')
        }
      };
      reader.onerror = reject;
    })
  }),
  getIdentifyProgress: (params) => http.get('/marking-exam-manager/tiny-client/recognition-process', params),// 获取识别进度
  getClientUpdateState: (params) => http.get('/marking-exam-manager/client-version/notify-teacher', params), // 获取客户端更新状态
  updateClientUpdateStatus: (params) => http.put('/marking-exam-manager/client-version/has-notify-teacher', params, 'form'), // 修改客户端更新状态
}

// 公告
export const noticeApi = {
  getNoticeList: params => http.post('/marking-platform/notices/', params), // 获取公共列表
  getPopNotice: () => http.post('/marking-platform/notices/my-alert?autoSave=true'), // 获取弹窗公告
  updateNoticeStatus: noticeId => http.put(`/marking-platform/notices/read-status?sysNoticeId=${noticeId}`), // 标记已读
}

// 切录题
export const recordQuestionApi = {
  queryExamQuestion: (params) => http.get('/marking-question/public/question/paper/quests/old', params, 'form'), // 查询考试题目
  uploadExamQuestsByPdf: (params) => http.post('/marking-question/public/image/question/paper/quests/old', params), // 上传pdf考试题目
  queryExamQuestionList: (params) => http.get('/marking-question/public/image/question/paper/list/quests/old', params, 'form').then(resp => {
    if (resp.body) {
      networkData.getRecordQuestions(resp.body)
    }
    return resp
  }), // 获取考试试题
  officeToImage: (params) => http.post('/marking-question/public/image/question/officeToImage', params, 'form'), // 将Office转为图片
  listByOfficeUrl: (params) => http.post('/marking-question/public/image/question/listByOfficeUrl', params, 'form'), // 根据officeUrl查询图片
}

export const cutQuestionApi = {
  uploadExamQuestsByPdf: (params) => http.post('/marking-question/public/image/question/paper/quests', params), // 上传pdf考试题目
  queryCutQuestionList: (params) => http.get('/marking-question/public/image/question/paper/list/quests', params, 'form'), // 获取考试试题
  listByOfficeUrl: (params) => http.post('/marking-question/public/image/question/listByOfficeUrl', params, 'form'), // 根据officeUrl查询图片
  word2html: params => http.post("/marking-platform/ossUpload/word2html", params),
  pdf2html: params => http.post("/marking-platform/ossUpload/upload/file/new", params),
  updateSingleExam: (params) => http.put(`/marking-exam-manager/exam-list/${params.id}`, params, 'json'), // 更新考试
  // 识别考试知识点
  recognizeQuesKnp: params => http.post('/marking-question/public/question/knowledge-point/recognition', params),
  // 获取识别到的知识点
  getRecognizeKnp: taskId => http.get(`/marking-question/public/question/knowledge-point/recognition/${taskId}`),
  // 获取考试知识点树
  getExamKnpTree: courseId => baseApi.getKnpList(courseId).then(resp => {
    setPointTree(resp)
    return resp
  })
}

export const configApi = {
  // 根据学校，年级获取科目
  getGradeSubjects: params => http.post(`/marking-platform/configurations/schools/subjects/list`, params),
  // 更新参数数值
  update: params => http.put(`/marking-platform/configurations/values`, params),
  // 根据学校，年级获取科目下面得分等级
  getSchoolLevels: (schoolId, grade, courseId) => http.get(`/marking-platform/configurations/schools/${schoolId}/grades/${grade}/values?courseId=${courseId}`),
  // 初始化学校的配置
  initSchool: schoolId => http.post(`/marking-platform/configurations/schools/${schoolId}`),
  // 根据学校，年级获取科目下面得分等级
  getSchoolLevelsByStage: (schoolId, stage) => http.get(`/marking-platform/configurations/schools/${schoolId}/stages/${stage}/level/values`).then(resp => {
    if (resp.body.showLevelConfigs) {
      configData.setOptionList(resp.body.showLevelConfigs)
    }
    return resp
  }),
  // 根据类型列表获取配置详情
  getConfigByTypes: (schoolId, types) => http.post(`/marking-platform/configurations/schools/${schoolId}/configTypes`, types).then(resp => {
    configData.setOptions(resp)
    return resp
  })
}

function setPointTree (resp) {
  const list = []
  if (resp.body) {
    for (let index = 0; index < resp.body.length; index++) {
      const element = resp.body[index];
      const target = list.find(item => item.id === element.id)
      if (target) continue
      const item = {}
      item.id = element.id
      item.label = element.name
      item.name = element.name
      item.pid = element.parentId
      item.subjectId = -1
      item.children = pointNodeChildren(element)
      list.push(item)
    }
  }
  resp.body = list
}

function pointNodeChildren (node) {
  let children = null
  if (node.children) {
    children = []
    for (let index = 0; index < node.children.length; index++) {
      const element = node.children[index];
      const item = {}
      item.id = element.id
      item.label = element.name
      item.name = element.name
      item.pid = element.parentId
      item.subjectId = -1
      item.children = pointNodeChildren(element)
      children.push(item)
    }
  }
  return children
}
